import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { THEME_COLOR3 } from "../../../constants";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const FALLBACK_IMAGE = "https://via.placeholder.com/300x200?text=No+Image";

const MenuLayoutCard = ({ data, onEdit, onDelete }) => {
  const { name, description, image } = data;

  return (
    <Box sx={styles.cardContainer}>
      <Box sx={styles.imageContainer}>
        <img
          src={image}
          alt={name}
          style={styles.image}
          onError={(e) => {
            e.target.src = FALLBACK_IMAGE;
          }}
        />
      </Box>
      
      <Box sx={styles.contentContainer}>
        <Box sx={styles.headerRow}>
          <Typography variant="h6" sx={styles.name}>
            {name}
          </Typography>
          <Box sx={styles.actionsContainer}>
            <Tooltip title="Edit">
              <IconButton
                size="small"
                onClick={() => onEdit(data)}
                sx={styles.iconButton}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                size="small"
                onClick={() => onDelete(data)}
                sx={styles.iconButton}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        
        {description && (
          <Typography variant="body2" sx={styles.description}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MenuLayoutCard;

const styles = {
  cardContainer: {
    border: `1.5px solid ${THEME_COLOR3}`,
    borderRadius: 2,
    overflow: "hidden",
    backgroundColor: "#FFF",
    transition: "all 0.3s ease",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      transform: "translateY(-2px)",
    },
  },
  imageContainer: {
    width: "100%",
    height: 250,
    overflow: "hidden",
    backgroundColor: "#f5f5f5",
    flexShrink: 0,
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  contentContainer: {
    padding: 2,
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 1,
  },
  name: {
    fontFamily: "GilroyBold",
    fontSize: 16,
    flex: 1,
    wordBreak: "break-word",
  },
  actionsContainer: {
    display: "flex",
    gap: 0.5,
  },
  iconButton: {
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
    },
  },
  description: {
    fontFamily: "GilroyRegular",
    fontSize: 14,
    color: "#666",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
